import type { PropsWithChildren } from 'react';
import { useCallback, useMemo } from 'react';

import { UserContext } from '../contexts';
import { useWmgSession } from '../hooks/useWmgSession';

export function UserProvider({ children }: PropsWithChildren) {
  const { email, name, permissions, features, isInternal, profile, userId } =
    useWmgSession();

  const hasPermission = useCallback(
    (permission: string, entityID?: string) => {
      if (entityID) {
        return permissions[entityID]?.includes(permission) ?? false;
      }

      return Object.values(permissions).some((items) =>
        items.includes(permission),
      );
    },
    [permissions],
  );

  const user = useMemo(() => {
    return {
      email,
      name,
      permissions,
      hasPermission,
      features,
      isInternal,
      profile,
      userId,
    };
  }, [
    email,
    features,
    hasPermission,
    isInternal,
    name,
    permissions,
    profile,
    userId,
  ]);

  return <UserContext.Provider value={user}>{children}</UserContext.Provider>;
}

UserProvider.displayName = 'UserProvider';
